/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.1.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import 'core-js/features/object/entries';
import expert_handler from "./Expert_handler";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
// import routes from "./routes/routes";
import routes from "./routes/expert_route";

import "./registerServiceWorker";
import Cookies from "js-cookie";
import axios from "axios";
import { Apis } from "./constants";


// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (sessionStorage.getItem("sessionChecked") == null) {   // check cookies is valid on server yet
      let resp = await axios.get(Apis.is_auth_valid, {
        withCredentials: true,
      });
      if (resp.data.result == "true") {
        next();
      } else {
        try {
          localStorage.removeItem('userID');
          localStorage.removeItem('session_id');
          localStorage.removeItem('username');
          Cookies.remove('userID');
          Cookies.remove('session_id');
        } catch (error) {
          console.log("error: ", error);
        }
      }
      sessionStorage.setItem("sessionChecked", "true");
    }
    if (localStorage.getItem("session_id") == null) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});

Vue.prototype.$expert = expert_handler;
